import Application from "../../Application";
import { LanguageCodes, UserPreferences } from "../../common/Constants";
import { ICredentialService } from "../../service/credential/CredentialService";
import PasswordResetPresenter, {
  IPasswordResetPresenter
} from "../../presenter/authentication/PasswordResetPresenter";
import PasswordResetCredentials, {
  TPasswordResetCredentials
} from "../../model/authentication/PasswordResetCredentials";

export default class ShowPasswordResetConfirmationInteractor {
  private application: Application;
  private output?: IPasswordResetPresenter;
  private credentialService: ICredentialService;

  constructor({
    application,
    credentialService
  }: {
    application: Application;
    credentialService: ICredentialService;
  }) {
    this.application = application;
    this.credentialService = credentialService;
  }

  execute(userId: string, token: string, lang: string) {
    const language =
      lang && Object.values(LanguageCodes).includes(lang)
        ? lang
        : UserPreferences.DEFAULT_LANGUAGE;

    this.output = PasswordResetPresenter({
      application: this.application,
      initialState: {
        languageCode: language,
        credentials: PasswordResetCredentials({} as TPasswordResetCredentials)
      }
    });

    this.application.container.registerValue("language", language);
    this.credentialService.setLanguage(language);
    this.output.confirmPasswordReset(userId, token);
    return this.output;
  }
}
